module.exports = __webpack_public_path__ + "img/bg_wibo.36633256.png";